export default __webpack_public_path__ + "static/hero_mini_1-ba479640b0d836f7a7c4ac9d950601bc.jpg";